const contact = {
    metaTitle: 'Contact',
    metaDescription:
      'Contact Oracle Consults about backend consulting, system reviews, integration cleanup, and workflow-heavy software projects.',
    eyebrow: 'Start the conversation',
    title: 'Tell me what is breaking, slow, or hard to trust.',
    lead:
      'The best first message is simple: tell me where the backend hurts today, what the system is supposed to do, and what kind of collaboration you are looking for.',
    fitTitle: 'Good fit projects',
    fitList: [
      'Inventory, order, reservation, and reporting backends',
      'Payment, logistics, or third-party integration cleanup',
      'SQL performance and data-flow bottleneck review',
      'Architecture review before a bigger rebuild or product push'
    ],
    contactMethods: [
      { label: 'Email', value: 'oreste.twizeyimana99@gmail.com', href: 'mailto:oreste.twizeyimana99@gmail.com' },
      { label: 'Phone', value: '+48 572 170 919', href: 'tel:+48572170919' },
      { label: 'GitHub', value: 'github.com/stere8', href: 'https://github.com/stere8/' },
      { label: 'LinkedIn', value: 'twizeyimana-o-2302a410a', href: 'https://www.linkedin.com/in/twizeyimana-o-2302a410a' }
    ],
    directContactTitle: 'Direct contact',
    discoveryTitle: 'What happens on the call',
    discoveryIntro:
      'If booking is easier than writing a long message, the discovery call is the fastest way to turn a vague backend problem into a sharper plan.',
    discoveryBullets: [
      'We identify the workflow, system pressure point, and urgency.',
      'I explain what I would inspect first and what kind of engagement fits.',
      'You leave with practical clarity, even if the next step is small.'
    ],
    scheduleButtonLabel: 'Schedule a discovery call',
    closing:
      'If a short call is easier than a long message, book directly and I will come prepared to talk about the system, the bottlenecks, and the best next step.'
  };

export default contact;
